/**
 * JavaScript functionality for i8n (internationalization) and translations.
 */



/**
 * Module constants
 */

export const URL_LANGUAGE_BASES =
{
	'swedish': '',
	'english': 'en',
};

export const TRANSLATIONS =
{
	'wisesite':
	{
		'searchURL':
		{
			'swedish': '/' + URL_LANGUAGE_BASES[ 'swedish' ],
			'english': '/' + URL_LANGUAGE_BASES[ 'english' ],
		},
		'searchFieldLabel':
		{
			'swedish': 'Sök...',
			'english': 'Search...',
		},
	},
};





/**
 * Wrapper function to make i18n's `__()` directly importable.
 */
export function __( translatable, textDomain )
{
	// Call i18n's function
	return i18n.__( translatable, textDomain );
}





/**
 * Main class for i18n.
 */
export class i18n
{
	/**
	 * Translates a specified key using a specified text domain.
	 *
	 * @param      {boolean}  translatable  The translatable
	 * @param      {boolean}  textDomain    The text domain
	 * @return     {string}   Relevant string translation if found, or an empty
	 *                        string if not found
	 */
	static __( translatable = false, textDomain = false )
	{
		try
		{
			// Instantiate current class
			let Instance = new i18n();

			// Make sure both values were provided
			if ( false === translatable && false === textDomain )
			{
				throw 'You need to specify both what to translate and the text domain it belongs to.';
			}

			// Make sure that text domain exists
			if ( typeof TRANSLATIONS[ textDomain ] === 'undefined' )
			{
				throw 'Invalid text domain ("' + textDomain + '").';
			}

			// Make sure that text domain exists
			if ( typeof TRANSLATIONS[ textDomain ][ translatable ] === 'undefined' )
			{
				throw 'Translation for "' + translatable + '" doesn\'t exist in text domain "' + textDomain + '".';
			}

			// Make sure that it's been translated to that language
			if ( typeof TRANSLATIONS[ textDomain ][ translatable ][ Instance.currentLanguage ] === 'undefined' )
			{
				throw '"' + translatable + '" has not yet been translated to "' + Instance.currentLanguage + '" for text domain "' + textDomain + '".';
			}

			// All good then, return it!
			return TRANSLATIONS[ textDomain ][ translatable ][ Instance.currentLanguage ];
		}
		catch( err )
		{
			// Make sure console is available
			if ( typeof console === 'object' )
			{
				// Do we have `console.warn()`?
				if ( typeof console.warn === 'function' )
				{
					console.warn( 'i18n: ' + err );
				}
				// Otherwise just go for log
				else if ( typeof console.log === 'function' )
				{
					console.log( 'i18n: ' + err );
				}
			}

			// Return an empty string
			return '';
		}
	}





	/**
	 * Gets the current language.
	 */
	static getCurrentLanguage()
	{
		// Instantiate default language so we can populate the variable later
		let defaultLanguage;

		// Start off by assuming we couldn't find the current language
		let currentLanguage = false;

		// Get current path without leading and trailing slashes
		let currentPath = window.location.pathname.replace( /^\/|\/$/g, '' );

		// Loop languages
		for ( let language in URL_LANGUAGE_BASES )
		{
			// If this is the default language
			if ( '' === URL_LANGUAGE_BASES[ language ] )
			{
				// Set default language
				defaultLanguage = language;
			}
			// If current path literally matches this language or start with current language and slash
			else if ( URL_LANGUAGE_BASES[ language ] === currentPath || 0 === currentPath.indexOf( URL_LANGUAGE_BASES[ language ] + '/' ) )
			{
				// Set current language to this language
				currentLanguage = language;

				// Break the loop as we've found our match
				break;
			}
		}

		// If no language matched, then it means we're on the default language
		if ( false === currentLanguage )
		{
			// Set current language to default language
			currentLanguage = defaultLanguage;
		}

		// Return what we found out
		return currentLanguage;
	}





	/**
	 * Class constructor.
	 */
	constructor()
	{
		// Member variables
		this.currentLanguage = i18n.getCurrentLanguage();
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/i18n/i18n.js